export { default as getComposerThemeConfig } from './getComposerThemeConfig';
export type { ComposerThemeConfig } from './getComposerThemeConfig';
